import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import more from 'highcharts/highcharts-more';
import * as moment from 'jalali-moment';
import { CompleteFormService } from 'src/app/services/api/complete-form.service';
import { CriteriaService, GeneralService, GlobalService } from 'src/app/services/index.service';
more(Highcharts);

@Component({
  selector: 'app-polar',
  templateUrl: './polar.component.html',
  styleUrls: ['./polar.component.scss']
})
export class PolarComponent implements OnInit{
  @Input() spiderChart:any;
  @Input() user:any;
  @Input() exam:any;
  @Input() shortShow:boolean = false;
  public loadingData: boolean = true;

  /* HighChart */
  public updateFlag: boolean = true; // optional boolean
  public oneToOneFlag: boolean = true; // optional boolean, defaults to false
  Highcharts: typeof Highcharts = Highcharts;
  public chartConstructor: string = "chart"; // optional string, defaults to 'chart'
  // Highcharts: any = Highcharts;
  chartOptions: Highcharts.Options = {
    
  }
  point:any;
  outputType:string = '';
  chartLIst:any = []
  chartColor:string = '#000';

    constructor(
    private GeneralService:GeneralService,
    private completeForm:CompleteFormService,
    private globalService:GlobalService,
    private criteriaService:CriteriaService
  ) { }

  tooltipList = ['Tooltip 1', 'Tooltip 2', 'Tooltip 3', 'Tooltip 4']; // Your tooltip list


  ngOnInit(): void {
    // console.log('before : ',this.spiderChart)
    this.outputType = this.spiderChart.output_type
    this.chartColor = this.spiderChart.chart_color
    let isSortable = this.spiderChart.sortable
    this.createChartList()
    this.criteriaService.CanExit = true
    if(isSortable) this.sortChart()
    const scoreValues = this.scoreArray();
    const tooltipList = this.tooltipArray();
    this.chartOptions = {
      series: [
        {
          name: '',
          type: 'line',
          data: [],
          pointPlacement: 'on'
        }
      ],
      chart: {
      
        polar: true,
        type: "line"
      },
      pane: {
        size: "80%"
      },
  
      xAxis: {
        categories: [],
        tickmarkPlacement: "on",
        lineWidth: 0,
      },
  
      yAxis: {
        gridLineInterpolation: "polygon",
        lineWidth: 0,
        min: 0
      },
      tooltip: {
        formatter: function() {
          let pointIndex = this.point.index;
          return tooltipList[pointIndex];
        }
      }
    }
    
    scoreValues.forEach((value:any ,index:any) => {
      let chart = this.chartLIst[index];
      (this.chartOptions as any).series[0].color = this.chartColor;
      (this.chartOptions as any).series[0].data.push(chart.score);
      (this.chartOptions as any).xAxis.categories.push(
        `<div style='color:${chart.color}'>
        ${chart.show} (${this.GeneralService.ConvertToPr(value.toString())}${this.outputType=='PERCENTAGE'?'%':''})
        </div>`
      );
    });
    
    this.loadingData = false;
    
  }
  getBackButton(){
    return this.completeForm.getBackButton()
  }
  getTimePerMinutes(time:string){
    return this.globalService.convertTime(time)
  }
  returnLastTakeExamDay(data:any){
    let NDay:any;
    let lastExamTime = Date.parse(moment(data,'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let newDateTime = Date.parse(moment(new Date(),'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let n_diff = (newDateTime-lastExamTime)/(1000 * 60 * 60 * 24)
    if(n_diff<=1){
      NDay = 'امروز'
    }else if(n_diff > 1 && n_diff < 1.5){
      NDay = 'دیروز'
    }else{
      let round = Math.ceil(n_diff)
      NDay = `${round} روز قبل` 
    }
    return NDay
  }
  scrollToTop(){
    this.globalService.scrollTop()
    this.completeForm.setBackButton(null)
  }
  scoreArray(){
    let arr:number[] = [];
    this.chartLIst.forEach((item:any) => arr.push(item.score))
    return arr;
  }
  tooltipArray(){
    let arr:string[] = [];
    this.chartLIst.forEach((item:any) => {
      arr.push(
        `
          <div class='flex items-center justify-start flex-col text-white'>
            <p class='inline-block font-extrabold title-label' style='color:${item.color}'>${item.charType.type_explain} (${this.GeneralService.ConvertToPr(item.score.toString())}${this.outputType=='PERCENTAGE'?'%':''})</p><br>
            <p class='text-xs text-lightMode-600 tooltip-description'>
              ${item.charType.type_description}
            </p>
          </div>
        `
      )
    })
    return arr;
  }
  createChartList(){
    for(let i in Object.values(this.spiderChart)){
      if(
        Object.values(this.spiderChart)[i]!="PERCENTAGE" && 
        Object.values(this.spiderChart)[i]!="NUMBER" && 
        Object.keys(this.spiderChart)[i]!="chart_color" && 
        Object.keys(this.spiderChart)[i]!="chart_type" && 
        Object.values(this.spiderChart)[i]!=undefined && 
        typeof Object.values(this.spiderChart)[i]!='boolean'
      ){
        this.chartLIst.push(Object.values(this.spiderChart)[i])
      }
    }
  }
  onSelect(event:any) {
    console.log(event);
  }


  chartCallback(): void {
    this.loadingData = false;
  } // optional function, defaults to null


  getCharType(){
    let charType:string[] = [];
    this.chartLIst.forEach((item:any) => {if(item.show) charType.push(item.show)})
    return charType.join('')
  }
  sortChart(){
    let sortedProducts = this.chartLIst.sort(
      (p1:any, p2:any) => (p1.score < p2.score) ? 1 : (p1.score > p2.score) ? -1 : 0);
    this.chartLIst = sortedProducts
  }
}
